import React from 'react'
import ImageWithBasePath from '../../../../core/common/imageWithBasePath'
import { BannerSelect } from '../../../../core/common/selectOption/json/selectOption'
import CustomSelect from '../../../../core/common/commonSelect'
import CountUp from 'react-countup'
import { all_routes } from '../../../router/all_routes'
import { Link, useNavigate } from 'react-router-dom'
import Slider from 'react-slick';


interface BannerProps {
    apiValues: any;
    miniBannerValues: any[];
    extraVal: any;
    scrollToSeventh: () => void; // ✅ Add this line

}

const Banner: React.FC<BannerProps> = ({ apiValues, miniBannerValues, extraVal, scrollToSeventh }) => {

    const testimonialslider = {
        dots: false,
        infinite: apiValues?.length > 1, // disable infinite if only one
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: apiValues?.length > 1, // disable autoplay if only one
        autoplaySpeed: 3000, // Speed in milliseconds (3 seconds)

        responsive: [
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };

    const route = all_routes
    const navigate = useNavigate();
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        const Path = route.courseList;
        navigate(Path);
    };

    return (
        <>
            {/* Home Banner */}
            <section className="banner-section-three d-flex align-items-center"
                style={{
                    // backgroundImage: `url(assets/img/palani-bg-gray.jpg)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    position: 'relative'
                }}
            >
                <ImageWithBasePath
                    src="assets/img/bg/bg-3.png"
                    alt="img"
                    className="img-fluid banner-bg-01"
                />
                <ImageWithBasePath
                    src="assets/img/bg/bg-4.png"
                    alt="img"
                    className="img-fluid banner-bg-02"
                />
                <div className="container">
                    <div className="row ">
                        <div className="col-lg-6 d-flex flex-column gap-3 !text-red-500">

                            {apiValues?.length > 1 ? (
                                <Slider {...testimonialslider}
                                    className="mentor-testimonial lazy slider aos"
                                    data-aos="fade-up"
                                    data-sizes="50vw "
                                >
                                    {

                                        (Array.isArray(apiValues) ? apiValues : []).map((item: any, index: number) => {

                                            return (
                                                // <div>{index}</div>
                                                <div className="home-slide-face aos">
                                                    <div className="home-slide-text">
                                                        <span className="fw-bold text-uppercase text-[#ff0000]">

                                                            {
                                                                item?.title
                                                            }
                                                        </span>

                                                        <h1 className="mt-4 text-[#1D1753]">
                                                            {
                                                                item?.description
                                                            }
                                                            {/* Your Gateway to
                                                        Global{" "}
                                                        <span className="text-secondary"> Education
                                                        </span>Opportunities */}
                                                        </h1>
                                                        <p className="mt-4 text-[#1D1753]">

                                                            {item?.miniDescription}
                                                        </p>
                                                    </div>

                                                    <div className="trust-user">
                                                        <h5 className='!text-[#ff0000]'>
                                                            {
                                                                item?.miniText
                                                            }
                                                        </h5>
                                                        <div className='flex gap-3'>
                                                            <Link
                                                                to={route.contact}>
                                                                <button className='bg-[#ff0000] text-white rounded-full px-4 py-2 mt-4'>
                                                                    Contact us
                                                                </button>
                                                            </Link>
                                                            {/* <Link to='/'> */}
                                                            <button onClick={scrollToSeventh} className='bg-[#1D1753] text-white rounded-full px-4 py-2 mt-4'>
                                                                Explore Destination
                                                            </button>
                                                            {/* </Link> */}

                                                        </div>
                                                        <div className="trust-rating d-flex align-items-center">
                                                            <div className="rate-head">
                                                                {/* <h2>
                                                                <span><CountUp end={item?.count
                                                                } /></span>+
                                                            </h2> */}
                                                            </div>
                                                            {/* <div className="rating d-flex align-items-center">
                                                            <h2 className="d-inline-block average-rating text-[#FFB54A]">
                                                                {item?.starCount}
                                                            </h2>
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                        </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            )

                                        }) || []

                                    }
                                </Slider>
                            ) : ((Array.isArray(apiValues) ? apiValues : []).map((item: any, index: number) => {

                                return (
                                    // <div>{index}</div>
                                    <div className="home-slide-face aos">
                                        <div className="home-slide-text">
                                            <span className="fw-bold text-uppercase text-[#ff0000]">

                                                {
                                                    item?.title
                                                }
                                            </span>

                                            <h1 className="mt-4 text-[#1D1753]">
                                                {
                                                    item?.description
                                                }
                                                {/* Your Gateway to
                                                        Global{" "}
                                                        <span className="text-secondary"> Education
                                                        </span>Opportunities */}
                                            </h1>
                                            <p className="mt-4 text-[#1D1753]">

                                                {item?.miniDescription}
                                            </p>
                                        </div>

                                        <div className="trust-user">
                                            <h5 className='!text-[#ff0000]'>
                                                {
                                                    item?.miniText
                                                }
                                            </h5>
                                            <div className='flex gap-3'>
                                                <Link
                                                    to={route.contact}>
                                                    <button className='bg-[#ff0000] text-white rounded-full px-4 py-2 mt-4'>
                                                        Contact us
                                                    </button>
                                                </Link>
                                                {/* <Link to='/'> */}
                                                <button onClick={scrollToSeventh} className='bg-[#1D1753] text-white rounded-full px-4 py-2 mt-4'>
                                                    Explore Destination
                                                </button>
                                                {/* </Link> */}

                                            </div>
                                            <div className="trust-rating d-flex align-items-center">
                                                <div className="rate-head">
                                                    {/* <h2>
                                                                <span><CountUp end={item?.count
                                                                } /></span>+
                                                            </h2> */}
                                                </div>
                                                {/* <div className="rating d-flex align-items-center">
                                                            <h2 className="d-inline-block average-rating text-[#FFB54A]">
                                                                {item?.starCount}
                                                            </h2>
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                            <i className="fas fa-star filled" />
                                                        </div> */}
                                            </div>
                                        </div>
                                    </div>
                                )

                            }) || []
                            )}
                        </div>


                        <div className="col-lg-6 d-flex align-items-center justify-center ">
                            <div className="banner-image" >

                                {/* <ImageWithBasePath src="assets/img/hero/hero-2.png" alt="Img" /> */}
                                <ImageWithBasePath
                                    source={
                                        extraVal
                                    }
                                    style={{
                                        height:"450px"
                                    }}
                                    // height={250}
                                    alt="Img"
                                />




                            </div>
                        </div>

                    </div>
                </div>
            </section>
            {/* /Home Banner */}

            <div className="section -mt-12 bg-[#fafafa]">
                <div className="container relative">
                    <div className="course-widget">
                        <div className="row row-gap-4 ">
                            {

                                (Array.isArray(miniBannerValues) ? miniBannerValues : []).map((item: any, index: number) => {
                                    return (<div className="col-lg-3 col-md-6 d-flex ">
                                        <div className="expert-item flex-fill newGradient  cursor-pointer" onClick={() => {
                                            navigate(`/${item?.navigateUrl}`)
                                        }}>

                                            <div className="expert-img" >
                                                {/* <ImageWithBasePath src="assets/img/icons/icon-24.svg" alt="Img" /> */}
                                                <ImageWithBasePath
                                                    source={
                                                        item?.iconUrl
                                                    }
                                                    className="rounded-full"
                                                    height={40}
                                                    width={40}
                                                    alt="Img"
                                                />
                                                {/* <i className={item?.iconUrl || "isax isax-book-1 fs-24 text-primary"} /> */}

                                            </div>
                                            <div className="expert-content">
                                                <h4>
                                                    <span className="counterup">
                                                        {/* <CountUp end={10} /> */}
                                                        {item.title}</span>
                                                </h4>
                                                <p>{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                    )
                                }) || []
                            }

                        </div>
                    </div>
                </div>
            </div>

        </>

    )
}

export default Banner
